import { Button } from '@/components/ui/button';

interface PainAwareLandingHeroProps {
  h1: string;
  subtitle: string;
  ctaText: string;
  ctaAction: () => void;
  backgroundGradient?: 'primary' | 'secondary' | 'accent';
  visualContent?: React.ReactNode;
}

export const PainAwareLandingHero = ({
  h1,
  subtitle,
  ctaText,
  ctaAction,
  backgroundGradient = 'primary',
  visualContent
}: PainAwareLandingHeroProps) => {
  return (
    <section className="relative border-b py-24 md:py-32 overflow-hidden">
      {/* Enhanced gradient background with animation */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-primary/5 via-background to-secondary/10"></div>
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-primary/20 to-primary/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-gradient-to-tr from-secondary/20 to-primary/10 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }}></div>
      </div>
      
      <div className="container mx-auto px-4">
        <div className={`${visualContent ? 'grid lg:grid-cols-2 gap-12 items-center' : 'max-w-4xl mx-auto text-center'}`}>
          {/* Text Content */}
          <div className={visualContent ? '' : 'text-center'}>
            <h1 className={`mb-6 text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl animate-fade-in ${!visualContent ? 'text-center' : ''}`}>
              {h1}
            </h1>
            <p className={`mb-8 text-lg text-muted-foreground sm:text-xl md:text-2xl animate-fade-in ${!visualContent ? 'max-w-3xl mx-auto' : ''}`} style={{ animationDelay: '0.1s' }}>
              {subtitle}
            </p>
            <div className={`flex flex-col sm:flex-row gap-4 ${!visualContent ? 'justify-center' : ''} animate-fade-in`} style={{ animationDelay: '0.2s' }}>
              <Button size="lg" onClick={ctaAction} className="text-lg px-8 py-6">
                {ctaText}
              </Button>
            </div>
          </div>
          
          {/* Visual Content (optional) */}
          {visualContent && (
            <div className="relative animate-fade-in" style={{ animationDelay: '0.3s' }}>
              {visualContent}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
